
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class HoldingWhitelistGrid extends SiteEntityGrid<HoldingWhitelistRow, any> {
        protected getColumnsKey() { return 'Rebalancer.HoldingWhitelist'; }
        protected getDialogType() { return HoldingWhitelistDialog; }
        protected getIdProperty() { return HoldingWhitelistRow.idProperty; }
        protected getLocalTextPrefix() { return HoldingWhitelistRow.localTextPrefix; }
        protected getService() { return HoldingWhitelistService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}